import React, { Component, Fragment } from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import { TopicLoader } from '../../Loader/loader';
import { secondsToTime1, secondsToTime, checkDateDifference, convertDate } from '../../utils/miscelleneous';
import EllipsisText from "react-ellipsis-text";
import $ from 'jquery';
import axios from 'axios';
import ReactPlayer from "react-player";
import ReactAudioPlayer from 'react-audio-player';
import Modal from "react-bootstrap/Modal";
import SharePopup from '../SharePopup/sharePopup';
import SelectBubble from '../../utils/selectBubble';
import AddPodModal from '../Saved/addPodModal';
import { CourseProgressBar } from '../../utils/course-progress-bar';
import Snackbar from '@mui/material/Snackbar';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import QuizPopup from '../Quiz-popup/quizPopup';
import TestDetail from './testDetail';

var captured_time = 0,
    start_time = 0,
    interval_id,
    resourceTime;
var timer, timer1,
    visible = true;
var win
class ContentDetails extends Component {
    state = {
        subtopicTitle: '',
        page: 1,
        addToBubble: false,
        openWarn: false,
        start: null,
        complete: null,
        update: false,
        edit: false,
        isOpenQuiz: false
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0);
        const { podDetail, pods, cType, contentType, details, courseDetails } = this.props

        if (podDetail && (cType === 'skillpod' || cType === 'custom')) {
            await this.props.getPodSubtopics(podDetail?._id);
            await this.props.getPodResources(podDetail?._id, podDetail?.title);
            await this.setState({
                skillPodTitle: podDetail?.title,
                subtopicTitle: podDetail?.subtopics[0],
                subtopicCount: pods[0]?.resources?.length,
                rCount: podDetail?.resources,
                searchBool: details?.search
            }, () => {
                this.expand_all();
                // this.getActiveSubtopic(this.state.subtopicTitle, this.state.subtopicCount)
            });
        }
        if (cType === 'additional') {
            this.setState({
                contentType: contentType
            }, async () => {
                // await this.props.resetData();
                await this.props.getAdditionalContents(details?._id, contentType, 1);
            })
        }
        if (courseDetails) {
            this.setState({
                start: courseDetails?.started_at ? convertDate(courseDetails?.started_at) : null,
                started_at: courseDetails?.started_at ? courseDetails?.started_at : null,
                complete: courseDetails?.completed_at ? convertDate(courseDetails?.completed_at) : null,
                completed_at: courseDetails?.completed_at ? courseDetails?.completed_at : null,
                status: courseDetails?.status,
                title: courseDetails?.title,
                url: courseDetails?.url,
                description: courseDetails?.description
            })
        }
    }


    fetchAdditionalContent = () => {
        this.setState({
            page: this.state.page + 1,
        }, () => {
            this.props.getNextAdditionalContents(this.props.details?._id, this.state.contentType, this.state.page);
        });
    };

    onTabChange = (e) => {
        this.setState({
            contentType: e,
            page: 1
        }, async () => {
            // await this.props.resetData();
            await this.props.getAdditionalContents(this.props.details?._id, this.state.contentType, this.state.page);
        })
    }

    getActiveSubtopic = (subtopicTitle, count) => {
        window.scrollTo(0, 0);
        $("#accordian2").animate({ scrollTop: 0 }, "fast");
        this.setState({
            subtopicTitle,
            subtopicCount: count
        }, async () => {
            this.expand_all();
            // await this.props.resetResourceLoading();
            // await this.props.getResourcesFromsubtopic(subtopicTitle);
        });
    };

    getPodActive = (e, subtopicTitle) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.subtopicTitle === subtopicTitle) {
            this.setState({
                subtopicTitle: ""
            });
        } else {
            this.setState({
                subtopicTitle
            });
        }

    };

    mouseover = (e, id) => {
        this.setState({
            itemid: id,
            isHover: true
        })
    }

    mouseout = (e) => {
        this.setState({
            isHover: false
        })
    }

    onPause = async (isTrue) => {
        console.log('138', isTrue)
        var local_data = localStorage.getItem("time"),
            timestamp = new Date();
        let article_time = (this.props.activeFeedData?.type === "Article" || this.props.activeFeedData?.type === "Podcast" || this.props.activeFeedData?.type === "Document") ? localStorage.getItem("aTime") !== null ? JSON.parse(localStorage.getItem("aTime")) : 0 : 0;
        if (this.props.activeFeedData?.type === "Video") {
            var startTime = this.props.activeFeedData.duration !== null && this.props.activeFeedData.duration.split("-")[0].split(":").reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
            var endTime = this.props.activeFeedData.duration !== null && this.props.activeFeedData.duration.split("-")[1].split(":").reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
            resourceTime = endTime - startTime === 0 ? 120 : endTime - startTime;
        }
        if (local_data) {
            local_data = JSON.parse(local_data);
            if (local_data.r_id === this.props.activeFeedData?._id) {
                captured_time = local_data.total;
                timestamp = local_data.timestamp;
            }
            else {
                captured_time = 0;
            }
            if (!isTrue) {
                if (Math.round((local_data.total + article_time) / 1000) > Math.round(local_data.resourceTime * 0.7)) {
                    local_data.viewed = true;
                    local_data._id = this.props.podId;
                    local_data.total = Math.round((local_data.total + article_time) / 1000);
                    local_data.r_id = this.props.activeFeedData?._id
                    local_data.type = this.props.activeFeedData?.type
                    const update = local_data;
                    this.props.viewAnalytic(update);
                } else {
                    local_data.viewed = false;
                    local_data._id = this.props.podId
                    local_data.total = Math.round((local_data.total + article_time) / 1000);
                    local_data.r_id = this.props.activeFeedData?._id
                    local_data.type = this.props.activeFeedData?.type
                    const update = local_data;
                    this.props.viewAnalytic(update);
                }
                (this.props.cType === "skillpod" || this.props.cType === 'custom') && await this.props.getPodResources(this.props.podId, this.state.subtopic);
                this.state.activeTab === "skillpod" && await this.props.getResourcesFromsubtopic(this.state.subtopicTitle);
            }


        }

        clearInterval(this.state.id);
        var end_time = new Date().getTime();

        const obj = {
            _id: this.props.podId,
            r_id: this.props.activeFeedData?._id,
            type: this.props.activeFeedData?.type,
            browser: localStorage.getItem("browser"),
            device: localStorage.getItem("device"),
            url: this.props.activeFeedData?.url,
            uri: window.location.href,
            timestamp: timestamp,
            resourceTime: this.props.activeFeedData?.type === "Quiz" ? 0 : resourceTime,
            total: captured_time + (end_time - start_time),
            skill_id: (this.props.cType === "skillpod") ? this.props.skillId : this.props.cType === "custom" ? this.props.customSkillId : null,
            viewed: false,
        };
        localStorage.setItem("time", JSON.stringify(obj));
    };

    onPlayChange = () => {
        // if (this.props.activeFeedData?.type !== "Video" && !timer && this.props.isShow) {
        //     this.startTimer();
        // }
        var timestamp = new Date();
        start_time = new Date().getTime();
        if (this.props.activeFeedData?.type === "Video") {
            var startTime = this.props.activeFeedData.duration !== null && this.props.activeFeedData.duration.split("-")[0].split(":").reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
            var endTime = this.props.activeFeedData.duration !== null && this.props.activeFeedData.duration.split("-")[1].split(":").reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
            resourceTime = endTime - startTime === 0 ? 120 : endTime - startTime;
            this.onPause(true);
        }
        interval_id = setInterval(() => {
            var local_data = localStorage.getItem("time");

            if (local_data) {
                local_data = JSON.parse(local_data);
                if (local_data.r_id === this.props.activeFeedData?._id) {
                    captured_time = local_data.total;
                    timestamp = local_data.timestamp;
                } else {
                    localStorage.removeItem("time");
                    captured_time = 0;
                }
            }

            var current_time = new Date().getTime();

            const obj = {
                _id: this.props.podId,
                r_id: this.props.activeFeedData?._id,
                type: this.props.activeFeedData?.type,
                browser: localStorage.getItem("browser"),
                device: localStorage.getItem("device"),
                url: this.props.activeFeedData?.url,
                uri: window.location.href,
                timestamp: timestamp,
                resourceTime: this.props.activeFeedData?.type === "Quiz" ? 0 : resourceTime, // will be set based on the resource 'time' key
                total: new Date(captured_time + (current_time - start_time)).getDate() !== new Date(Date.now()).getDate() ? captured_time + (current_time - start_time) : 0,
                skill_id: (this.props.cType === "skillpod") ? this.props.skillId : this.props.cType === "custom" ? this.props.customSkillId : null,
                viewed: false,
            };

            start_time = new Date().getTime();
            console.log('248', obj.total)
            localStorage.setItem("time", JSON.stringify(obj));
        }, 1000);

        this.setState({
            id: interval_id,
        });
    };

    onEnded = () => {
        this.onPause(true);
    }

    showfeeds = async (el, type) => {
        window.scrollTo(0, 0);

        if (el?.type !== "Video") {
            await this.startTimer();
        }
        this.setState({
            resourceId: el._id,
            subtopicTitle: el.topic,
            active: type,
            videoFailed: false
        });
        await this.props.getResourceData(el.type, el._id, this.state.active);
        if (this.props.activeFeedData?.source?.toLowerCase() === "vimeo") {
            this.checkVimeo(this.props.activeFeedData?.url);
        }

        if (!this.props.allow) {
            this.setState({
                expireAlert: true,
            });
        } else {
            if (el.type === "Podcast") {
                this.onPlayChange();
                resourceTime = this.props.activeFeedData?.duration && this.props.activeFeedData?.duration !== null ? this.props.activeFeedData.duration.split(":").reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0) : 60;
            }
        }
    };

    showArticles = async (el) => {
        window.scrollTo(0, 0);
        this.setState({
            resourceId: el._id,
            subtopicTitle: el.topic,
        });
        await this.props.getResourceData(el.type, el._id, this.state.active);
        if (el?.type !== "Video") {
            await this.startTimer();
            if (el.type === "Article" || el.type === "Podcast" || el.type === "Document") {
                this.onPlayChange();
                resourceTime = this.props.activeFeedData?.duration && this.props.activeFeedData?.duration !== null ? this.props.activeFeedData.duration.split(":").reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0) : 120;
                this.goToArticles(this.props.activeFeedData?.url, true);
            }
        }
    }

    goToArticles = (url, close) => {

        if (close) {
            console.log('1')
            this.setState({
                article: true
            })
            window.innerWidth > 767 && $(".layout").show();
            var start_time = new Date();
            win = window.open(url, 'name', 'location=1,status=1,scrollbars=0,width=800,height=800,menubar=no,status=no,toolbar=no');
            win.moveTo(400, 0);
            if (win) win.focus();
            timer1 = setInterval(() => {
                if (win.closed) {
                    clearInterval(timer1);
                    this.setState({
                        article: false
                    })
                    var end_time = new Date();

                    var elapsed_ms = end_time - start_time;
                    var seconds = Math.round(elapsed_ms / 1000);
                    var minutes = Math.round(seconds / 60);
                    // var hours = Math.round(minutes / 60);

                    var sec = seconds;
                    // var min = minutes;
                    console.log(sec);
                    localStorage.setItem('aTime', sec * 1000)
                    $(".layout").hide();
                    this.stoptimer();
                    this.onPause(false);
                }
            }, 1000);
        } else {
            console.log('12')
            win && win.close();
            clearInterval(timer1);
            this.setState({
                article: false
            })
            $(".layout").hide();
            this.stoptimer();
            this.onPause();
        }

    }

    goToOriginal = (el, type) => {
        if (type === 'Course') {
            const obj = {
                _id: null,
                r_id: el?._id,
                type: 'Course',
                browser: localStorage.getItem("browser"),
                device: localStorage.getItem("device"),
                url: el.url,
                uri: window.location.href,
                timestamp: new Date(),
                resourceTime: 0,
                total: 0,
                skill_id: null,
                viewed: true,
            };
            this.props.viewAnalytic(obj);
            var win = window.open(el.url, 'name', 'location=1,status=1,scrollbars=0,width=800,height=800,menubar=no,status=no,toolbar=no');
            win.moveTo(350, 0);
        }
        else {
            window.open(el.url, '_blank');
        }
    }

    closeVideo = () => {
        this.stoptimer();
        this.onPause();
        this.props.backToList();
    }

    checkVimeo = (url) => {
        axios
            .get(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`)
            .then((result) => {
                this.setState({
                    status: result.status,
                });
            })
            .catch((err) => {
                this.setState({
                    status: err.response.status,
                });
            });
    };


    handleError = async (err, type, id) => {
        let obj = {
            resource_id: id,
            type: type
        }
        await this.props.sendVideoError(obj);
    }


    componentWillUnmount = () => {
        document.removeEventListener("visibilitychange", function (event) {
            if (document.hidden) {
                visible = false;
                clearInterval(timer);
                clearInterval(interval_id);
            } else {
                visible = true;
                this.startTimer();
            }
        });
    };

    startTimer = () => {
        timer = setInterval(this.countDown, 1000);
    };

    countDown = () => {
        let seconds = this.state.seconds + 1;
        this.setState({
            time: secondsToTime(seconds),
            seconds: seconds,
        });
    };

    stoptimer = () => {
        clearInterval(timer);
        timer = 0;
        this.setState({
            activeFeedData: [],
            seconds: 0,
            time: {},
        });
    };



    handleModal = async () => {
        await this.props.handleModalClose();
        await this.props.clearErrors();
    };

    saveContent = async (type, id) => {
        await this.props.getSkillPods();
        this.setState({
            addToBubble: true,
            r_type: type,
            r_id: id,
        });
    };


    selectBubble = async (podId) => {
        let obj = {
            pod_id: podId,
            type: this.state.r_type,
            _id: this.state.r_id,
        };
        await this.props.addResourceToPod(obj);
        await this.setState({
            addToBubble: false,
        });
        if (this.props.status === 200) {
            this.props.getSaved(this.state.r_id);
        }
    };

    resetModal = () => {
        this.setState({
            addToBubble: false,
        });
    };

    imageUpload = (e, id) => {
        if (e.target.files[0].size > 2097152) {
            this.setState({
                successMsg: true,
                successMessageText: "The file size cannot exceed 2MB",
            });
        } else {
            const file = this.refs.uploadImg.files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({
                    image: reader.result,
                });
            };
            reader.readAsDataURL(file);
            this.setState({
                imageName: file.name,
                image: file,
                imageError: "",
            }, async () => {
                const data = new FormData()
                data.append('course_id', id);
                data.append('image', this.state.image)
                await this.props.imageUploaded(data);
                await this.props.getCourseDetail(id);
                this.setState({
                    image: null
                })
            });

        }
    }

    setDate = async (val, type) => {

        if (type === 'start') {
            this.setState({
                start: convertDate(val),
                started_at: val,
                update: true
            })
        } else {
            this.setState({
                validTime: false
            }, async () => {
                await this.checkTime(val, this.state.started_at)
                if (!this.state.validTime) {
                    await this.setState({
                        complete: convertDate(val),
                        completed_at: val,
                        validTime: false,
                        update: true
                    })
                }
            })

        }
    }
    checkTime = (end, start) => {

        if (start !== null) {
            if (new Date(end) < new Date(start)) {
                this.setState({
                    validTime: true,
                    successEnable: true,
                    successMessageText: "End date should exceed the start date"
                })
            }
            else if (end === start?.split('T')[0]) {
                this.setState({
                    validTime: true,
                    successEnable: true,
                    successMessageText: "Start date and end date cannot be same"
                })
            }
            else {
                this.setState({
                    validTime: false
                })
            }
        } else {
            this.setState({
                validTime: false,
                successEnable: true,
                successMessageText: "Please select start date first"
            })
        }

        return false;
    }

    saveDates = async () => {
        if (checkDateDifference(this.state.completed_at) && (this.props.courseDetails?.certificate == null)) {
            this.setState({
                successEnable: true,
                successMessageText: "Please upload certificate"
            })
        } else {
            let obj = {
                course_id: this.props.courseDetails?._id,
                completed_at: this.state.completed_at,
                started_at: this.state.started_at,
                status: this.props.courseDetails?.certificate == null ? this.state.status : 'completed'
            }
            await this.props.updatedStatus(obj);
            await this.props.getCourseDetail(obj?.course_id);
            await this.setState({
                courseDetails: this.props.courseDetails,
                status: this.props.courseDetails?.status,
                update: false
            })
        }
    }

    showMessage = () => {
        this.setState({
            successEnable: true,
            successMessageText: (!this.state.validTime && !this.state.update) ? 'You have not made any changes' : 'Please check start and completion date'
        })
    }


    updateStatus = async (data, status) => {
        this.setState({
            status,
            openWarn: status == 'not_interested' ? false : true,
            msg: true,
            update: true
        }, async () => {
            if (status === 'not_interested') {
                let obj = {
                    course_id: data?._id,
                    status: this.state.status
                }
                await this.props.updatedStatus(obj);
                await this.props.getCourseDetail(obj?.course_id);
                await this.setState({
                    courseDetails: this.props.courseDetails,
                    status: this.props.courseDetails?.status,
                    update: false,
                    msg: false, openWarn: false
                })
            }
        })

    }

    onback = () => {
        if ((this.state?.status === 'started') && this.state.start == null) {
            this.setState({
                openWarn: true,
                msg: false
            })
        }
        else if (this.state.update || (this.state.start !== null) && (this.state.complete == null)) {
            this.setState({
                openWarn: true,
                msg: false
            })

        } else if (this.state.edit) {
            this.setState({
                openWarn: true,
                msg: null
            })
        }
        else {
            this.props.goBack();
        }
    }



    snackClosed = () => {
        this.props.clearErrors();
        this.setState({
            successEnable: false,
            successMessageText: ''
        })
    }

    expand_all() {
        this.setState({
            expand: true
        })
        $('.collapse').each(function () {
            $(this).addClass('show');
        });
        $('.acc').each(function () {
            $(this).attr('aria-expanded', 'true');
        });
    }
    collapse_all() {
        this.setState({
            expand: false
        })
        $('.collapse').each(function () {
            $(this).removeClass('show');
        });
        $('.acc').each(function () {
            $(this).attr('aria-expanded', 'false');
        });
    }

    changeContent = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }, () => {
            if (e.target.name === 'title') {
                this.setState({
                    titleErr: ''
                })
            }
        })
    }

    handleChangeUrl = async (evt) => {
        let regex =
            /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-/]))?/;
        let Extension = evt.target.value
            .substring(evt.target.value.lastIndexOf(".") + 1)
            .toLowerCase();
        if (!regex.test(evt.target.value)) {
            this.setState({
                urlErr: "Please enter valid link or paste url",
            });
            return false;
        }
        else {
            this.setState({ urlError: "", url: evt.target.value });
        }
    };


    editCourse = async () => {
        if (this.state.title === '') {
            this.setState({
                titleErr: `Title can't empty`
            })
        }
        else if (this.state.url === '') {
            this.setState({
                urlErr: `Url can't empty`
            })
        } else {
            let obj = {
                course_id: this.props.courseDetails?._id,
                title: this.state.title,
                description: this.state.description,
                url: this.state.url
            }

            await this.props.editedCourse(obj);
            await this.props.getCourseDetail(obj.course_id);
            this.setState({
                edit: false,

            })
        }
    }

    showQuiz = async (el) => {
        await this.props.getResourceData('Quiz', el._id);
        if (!this.props.allow) {
            this.setState({
                expireAlert: true,
            });
        } else {
            this.setState({
                isOpenQuiz: true
            })
            let timestamp = new Date();
            start_time = new Date().getTime();
            let current_time = new Date().getTime()
            const obj = {
                _id: this.props.podId,
                r_id: el?._id,
                type: 'Quiz',
                browser: localStorage.getItem("browser"),
                device: localStorage.getItem("device"),
                uri: window.location.href,
                timestamp: timestamp,
                resourceTime: el?.type === "Quiz" ? 0 : resourceTime, // will be set based on the resource 'time' key
                total: new Date(captured_time + (current_time - start_time)).getDate() !== new Date(Date.now()).getDate() ? captured_time + (current_time - start_time) : 0,
                skill_id: (this.props.cType === "skillpod") ? this.props.skillId : this.props.cType === "custom" ? this.props.customSkillId : null,
                viewed: false,
            };

            start_time = new Date().getTime();
            localStorage.setItem("time", JSON.stringify(obj));
        }
    }


    closePopup = () => {
        this.setState({
            isOpenQuiz: false
        })
    }

    openTestDetail = (id) => {
        this.setState({
            setLoading: true,
            isOpenDetail: true
        }, async () => {
            await this.props.getQuizHistory(id);
            this.setState({
                setLoading: false
            })
        })
    }


    render() {
        const { cType, details, contentLoading, t, theme, isResourceLoading, isSkillPathLoading, customSkillPods, skillPods, resource, isDataLoading, contentCount, additionalContent, pods, activeFeedData, courseDetails } = this.props
        const { contentType, edit } = this.state
        $(window).focus(() => {
            if (this.props.activeFeedData?.type !== "Video" && timer && this.props.isShow) {
                this.startTimer();
            }
            if (!interval_id && this.props.isShow) {
                this.onPlayChange();
            }
        });

        $(window).blur(function () {
            clearInterval(timer);
            timer = 0;
            clearInterval(interval_id);
            interval_id = 0;
        });

        if (this.props?.activeFeedData && this.props.activeFeedData?.type === 'Video') {
            var startTime = activeFeedData.duration !== null && activeFeedData.duration.split('-')[0].split(':').reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
            var endTime = activeFeedData.duration !== null && activeFeedData.duration.split('-')[1].split(':').reverse().reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0)
        }



        return (
            <div >
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={this.state.succesEnable}
                    onClose={() => this.snackClosed()}
                    message={this.state.successMessageText}
                    autoHideDuration={4000}
                />

                {!contentLoading ?
                    <Fragment>
                        {cType !== 'course' ?
                            <div className="elite-skill-details1">
                                {window.innerWidth > 767 ?
                                    <div className="row pl-0  align-items-center">
                                        <div className="col-md-8 d-flex cursor-pointer align-items-center">
                                            <img src="/images/chevron-left.svg" alt="" style={{ marginTop: 0 }} onClick={() => this.state.searchBool ? this.props.history.goBack() : this.props.goBack()} />{" "}
                                            &nbsp;<h3 className='d-flex align-items-center'>{details?.title}&nbsp;&nbsp;
                                                <p style={{ fontSize: 16, color: '#242326' }}>{cType === 'course' ? `(${t('Course', { ns: 'learn' })})` : cType === 'additional' ? `(${t('Learning Bytes', { ns: 'learn' })})` : `(${t('Curated content', { ns: 'learn' })})`}</p>
                                            </h3>
                                        </div>


                                    </div> :
                                    null
                                }
                            </div>
                            : null
                        }
                        {
                            cType !== 'course' ?
                                <div className='d-flex w-100 mt-2'>
                                    <div className="skill-topics">
                                        <div className="acc-overflow">
                                            <div id="accordian" >
                                                {(cType === 'skillpod') ? (
                                                    <Fragment>
                                                        {skillPods !== undefined &&
                                                            skillPods.map((el, idx) => {
                                                                return (
                                                                    <div className="card mb-0" style={{ backgroundColor: this.state.skillPodTitle === el.title ? '#332E59' : '#fff' }} onClick={(e) => {
                                                                        this.setState({
                                                                            skillPodTitle: el.title,
                                                                            rCount: el.resources,
                                                                            collapse: true
                                                                        }, async () => {
                                                                            await this.props.resetLoading();
                                                                            await this.props.getPodSubtopics(el._id);
                                                                            await this.props.getPodResources(el._id, el.title);
                                                                            await this.getActiveSubtopic(this.props.pods[0]?.title, this.props?.pods[0]?.resources?.length);

                                                                        }
                                                                        );
                                                                    }}>
                                                                        <div >
                                                                            <div style={{ marginRight: 0, }} className="d-flex justify-content-between align-items-center cursor-pointer">
                                                                                <div className="col-md-12 col-12 pr-0 recent-title">
                                                                                    <div className="d-flex justify-content-between align-items-center cursor-pointer">
                                                                                        <h1 style={{ fontSize: 14, color: this.state.skillPodTitle === el.title ? '#fff' : '#535259' }}>
                                                                                            {el.title !== undefined && (
                                                                                                <EllipsisText text={el.title} length={"80"} />
                                                                                            )}
                                                                                        </h1>
                                                                                        <div className="d-flex float-right" style={{ marginRight: -10 }}>
                                                                                            <div className="d-flex align-items-center" style={{ width: 30, }}>
                                                                                                <img src="/images/list-color.svg" alt="" width={16} />
                                                                                                &nbsp;
                                                                                                <h5 style={{ fontFamily: "Lato", color: "#5fbb97", fontSize: 14, }}>
                                                                                                    {
                                                                                                        el.resources
                                                                                                    }
                                                                                                </h5>
                                                                                            </div>{" "}
                                                                                            &nbsp;&nbsp;&nbsp;
                                                                                            <div className="d-flex align-items-center" style={{ width: 52, }}>
                                                                                                <img src="/images/pie-icon.svg" alt="" width={16} />
                                                                                                &nbsp;
                                                                                                <h5 style={{ fontFamily: "Lato", color: "#E7C15F", fontSize: 14, }}    >
                                                                                                    {Math.round(el.percent_viewed) > 95 ? 100 : Math.round(el.percent_viewed)}%
                                                                                                </h5>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                );
                                                            })}
                                                    </Fragment>
                                                ) :
                                                    cType === 'custom' ?
                                                        <div>
                                                            <div className="card mb-0">

                                                                {isSkillPathLoading ? (
                                                                    <div className="px-4">
                                                                        <TopicLoader />
                                                                    </div>
                                                                ) : (
                                                                    <div  >
                                                                        <div>
                                                                            {customSkillPods !== undefined &&
                                                                                customSkillPods.map((el, idx) => {
                                                                                    return (
                                                                                        <div className="card mb-0" style={{ backgroundColor: this.state.skillPodTitle === el.title ? '#332E59' : '#fff' }} >
                                                                                            <div
                                                                                                onClick={(e) => {
                                                                                                    this.setState({
                                                                                                        skillPodTitle: el.title,
                                                                                                        rCount: el.resources,
                                                                                                        collapse: true
                                                                                                    }, async () => {
                                                                                                        await this.props.resetLoading();
                                                                                                        await this.props.getPodSubtopics(el._id);
                                                                                                        await this.props.getPodResources(el._id, el.title);
                                                                                                        await this.getActiveSubtopic(this.props.pods[0]?.title, this.props?.pods[0]?.resources?.length);

                                                                                                    }
                                                                                                    );
                                                                                                }}
                                                                                            >
                                                                                                <div style={{ marginRight: 0, }} className="d-flex justify-content-between align-items-center cursor-pointer">
                                                                                                    <div className="col-md-12 col-12 pr-0 recent-title">
                                                                                                        <div className="d-flex justify-content-between align-items-center cursor-pointer">
                                                                                                            <h1
                                                                                                                className="body-text"
                                                                                                                style={{ fontSize: 14, color: this.state.skillPodTitle === el.title ? '#fff' : '#535259' }}>
                                                                                                                {el.title !== undefined && (
                                                                                                                    <EllipsisText style={{ color: this.state.skillPodTitle === el.title ? '#fff' : '#535259' }} text={el.title} length={"80"} />
                                                                                                                )}
                                                                                                            </h1>
                                                                                                            <div className="d-flex float-right" style={{ marginRight: 0 }}>
                                                                                                                <div className="d-flex align-items-center" style={{ width: 30, }}>
                                                                                                                    <img src="/images/list-color.svg" alt="" width={16} />
                                                                                                                    &nbsp;
                                                                                                                    <h5 style={{ fontFamily: "Lato", color: "#5fbb97", fontSize: 14, }}>
                                                                                                                        {
                                                                                                                            el.resources
                                                                                                                        }
                                                                                                                    </h5>
                                                                                                                </div>{" "}
                                                                                                                &nbsp;&nbsp;&nbsp;
                                                                                                                <div className="d-flex align-items-center" style={{ width: 52, }}>
                                                                                                                    <img src="/images/pie-icon.svg" alt="" width={16} />
                                                                                                                    &nbsp;
                                                                                                                    <h5 style={{ fontFamily: "Lato", color: "#E7C15F", fontSize: 14, }}    >
                                                                                                                        {Math.round(el.percent_viewed) > 95 ? 100 : Math.round(el.percent_viewed)}%
                                                                                                                    </h5>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        :
                                                        <div id="add">
                                                            <Fragment>
                                                                <div className="skill-header" style={{ padding: '12px 12px 10px 12px' }}>
                                                                    {contentCount && (
                                                                        <div className="resource-btns">
                                                                            {contentCount?.videos !== 0 && (
                                                                                <div className=" cursor-pointer">
                                                                                    <button className={contentType === "Video" ? "active d-flex justify-content-between" : "d-flex justify-content-between"} onClick={() => this.onTabChange("Video")}>
                                                                                        <small >
                                                                                            {t("Videos")}
                                                                                        </small>
                                                                                        <div className="d-flex justify-content-start align-items-center" style={{ width: '18%' }}>
                                                                                            <img src="/images/video-color-icon.svg" alt="" />
                                                                                            &nbsp; {contentCount?.videos}
                                                                                        </div>
                                                                                    </button>

                                                                                </div>
                                                                            )
                                                                            }
                                                                            {contentCount?.articles !== 0 && (
                                                                                <div className="text-center  cursor-pointer" onClick={() => this.onTabChange("Article")}>
                                                                                    <button className={contentType === "Article" ? "active d-flex justify-content-between" : "d-flex justify-content-between"}>
                                                                                        <small >
                                                                                            {t("Articles")}
                                                                                        </small>
                                                                                        <div className="d-flex justify-content-start align-items-center" style={{ width: '18%' }}>
                                                                                            <img src="/images/article-color-icon.svg" alt="" />
                                                                                            &nbsp; {contentCount?.articles}
                                                                                        </div>
                                                                                    </button>

                                                                                </div>
                                                                            )}
                                                                            {contentCount?.podcasts !== 0 && (
                                                                                <div
                                                                                    className="text-center  cursor-pointer" onClick={() => this.onTabChange("Podcast")}>
                                                                                    <button className={contentType === "Podcast" ? "active d-flex justify-content-between" : "d-flex justify-content-between"}>
                                                                                        <small >
                                                                                            {t("Podcasts")}
                                                                                        </small>
                                                                                        <div className="d-flex justify-content-start align-items-center" style={{ width: '18%' }}>
                                                                                            <img src="/images/podcast-color-icon.svg" alt="" />
                                                                                            &nbsp; {contentCount?.podcasts}
                                                                                        </div>
                                                                                    </button>

                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Fragment>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="subtopic-contents" id='containerDiv'>
                                        {(cType === 'skillpod' || cType === 'custom') ?
                                            <Fragment>
                                                <div className='d-flex justify-cotnent-between align-items-center'>
                                                    <h1 style={{ width: '95%' }}>{this.state.skillPodTitle}&nbsp;<span style={{ fontSize: 14, color: '#535259' }}>({this.state.rCount} {(t('Items', { ns: 'learn' }))})</span>
                                                    </h1>
                                                    <div style={{ display: 'flex', color: theme?.bgColor, fontSize: 12, cursor: 'pointer', width: '20%' }}>
                                                        {this.state.expand ? null :
                                                            <span className='cursor-pointer' onClick={() => this.expand_all()}>{t('Expand all', { ns: 'learn' })}</span>
                                                        }
                                                        {
                                                            this.state.expand ?
                                                                <span className='cursor-pointer' onClick={() => this.collapse_all()}>{t('Collapse all', { ns: 'learn' })}</span>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>

                                                {isResourceLoading ? (
                                                    <div className="pl-3 pr-3">
                                                        <TopicLoader />
                                                    </div>
                                                ) :
                                                    <div class="accordion" id="accordian2">
                                                        {pods !== undefined &&
                                                            pods.filter(el => { return el.resources?.length !== 0 }).map((el, idx) => {
                                                                return (
                                                                    <div class="card">
                                                                        <div class="card-header" id={idx}>
                                                                            <h2 class="mb-0">
                                                                                <a className='acc' type="button" data-toggle="collapse" data-target={`#${el._id}`} aria-expanded="true" aria-controls={el._id}>
                                                                                    <div style={{ marginLeft: 40, marginRight: 0, }} className="d-flex justify-content-between align-items-center cursor-pointer">
                                                                                        <div className="col-md-12 col-12 pl-0 pr-0 ">
                                                                                            <div className="cursor-pointer">
                                                                                                <h1
                                                                                                    className="body-text"
                                                                                                    style={{ fontSize: 14, }}>
                                                                                                    {el.title !== undefined && (
                                                                                                        <EllipsisText text={el.title} length={"80"} />
                                                                                                    )}
                                                                                                    <p >{el.resources?.length} {(t('Items', { ns: 'learn' }))}</p>
                                                                                                </h1>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </a>
                                                                            </h2>
                                                                        </div>

                                                                        <div id={el._id} class="collapse" aria-labelledby={idx} data-parent="#accordian2" style={{ padding: 10 }}>
                                                                            <div className="skill-pod-topics">
                                                                                <div id="accordion" className="accordion">
                                                                                    {isResourceLoading ? (
                                                                                        <div className="pl-3 pr-3">
                                                                                            <TopicLoader />
                                                                                        </div>
                                                                                    ) : (

                                                                                        <div id='resource-list' className="row" style={{ background: '#fff' }}>
                                                                                            {el?.resources !== null &&
                                                                                                el?.resources.map((items, index) => {
                                                                                                    var startTime = items.duration && items.duration !== undefined && items.duration.split("-")[0].split(":").reverse().reduce((prev, curr, i) =>
                                                                                                        prev + curr * Math.pow(60, i),
                                                                                                        0
                                                                                                    );
                                                                                                    var endTime = items.duration && items.duration !== undefined && items.duration.split("-")[1].split(":").reverse().reduce((prev, curr, i) =>
                                                                                                        prev + curr * Math.pow(60, i),
                                                                                                        0
                                                                                                    );
                                                                                                    var time1 = secondsToTime1(endTime - startTime);
                                                                                                    return (
                                                                                                        <div key={index} className="col-md-3 col-12 position-relative cursor-pointer" >
                                                                                                            <div className="row mt-2">
                                                                                                                <div className="col-md-12 col-6" onMouseOver={(e) => { this.mouseover(e, items?._id) }} onMouseOut={(e) => { this.mouseout(e) }} onClick={() => (items.type === 'Article' || items.type === 'Podcast' || items.type === 'Document') ? this.showArticles(items, "skillpod") : items.type === 'Quiz' ? this.showQuiz(items, 'skillpod') : items.type === 'Course' ? this.goToOriginal(items, 'Course') : this.showfeeds(items, "skillpod")} >

                                                                                                                    <img src={items.type === 'Quiz' ? '/images/quiz.jpg' : items.image ? items.image : "https://elite-product-images.s3.ap-south-1.amazonaws.com/articles_default_1.png"} width='100%' height={120} alt="" loading="lazy" style={{ borderRadius: 8, border: '1px solid rgb(233, 232, 242)' }} onError={(e) => {
                                                                                                                        if (e.target.src !== "/images/empty-image.png") {
                                                                                                                            e.target.onerror = null;
                                                                                                                            e.target.src = "/images/empty-image.png";
                                                                                                                        }
                                                                                                                    }
                                                                                                                    } />
                                                                                                                    <div className="content-tags" style={{ background: this.state.isHover && (this.state.itemid === items?._id) ? '#8B7DF2' : '#E7C15F' }}>
                                                                                                                        {
                                                                                                                            this.state.isHover && (this.state.itemid === items?._id) ?
                                                                                                                                <p className="d-flex align-items-center" style={{ color: '#fff' }}>
                                                                                                                                    {items.type === "Podcast" ? (
                                                                                                                                        <img src="/images/podcast-icon-white.svg" width="15px" alt="" />
                                                                                                                                    ) : items.type === "Video" ? (
                                                                                                                                        <img src="/images/video-icon-white.svg" width="15px" alt="" />
                                                                                                                                    ) : items.type === "Document" ? (
                                                                                                                                        <img src="/images/document-icon-white.svg" width="14px" alt="" />
                                                                                                                                    ) : items.type === "Course" ? (
                                                                                                                                        <img src="/images/course-icon-white.svg" width="15px" alt="" />
                                                                                                                                    ) : items.type === "Article" ? (
                                                                                                                                        <img src="/images/article-icon-white.svg" width="15px" alt="" />
                                                                                                                                    ) : items.type === "Quiz" ? (
                                                                                                                                        <img src="/images/quiz-icon-white.svg" width="15px" height={13} alt="" />
                                                                                                                                    ) : null}{" "}
                                                                                                                                    &nbsp;
                                                                                                                                    {items.type === "Video" ? 'Watch Video' : items.type === "Document" ? 'Read Document' : items.type === "Article" ? 'Read Article' : items.type === "Podcast" ? 'Listen Podcast' : items.type === "Course" ? 'Watch Course' : items.type === "Quiz" ? 'Take Quiz' : null}
                                                                                                                                </p> :
                                                                                                                                <p className="d-flex align-items-center">
                                                                                                                                    {items.type === "Podcast" ? (
                                                                                                                                        <img src="/images/podcast-icon-black.svg" width="15px" alt="" />
                                                                                                                                    ) : items.type === "Video" ? (
                                                                                                                                        <img src="/images/video-icon-black.svg" width="15px" alt="" />
                                                                                                                                    ) : items.type === "Document" ? (
                                                                                                                                        <img src="/images/document-icon-black.svg" width="12px" alt="" />
                                                                                                                                    ) : items.type === "Course" ? (
                                                                                                                                        <img src="/images/course-icon-black.svg" width="15px" alt="" />
                                                                                                                                    ) : items.type === "Article" ? (
                                                                                                                                        <img src="/images/article-icon-black.svg" width="15px" alt="" />
                                                                                                                                    ) : items.type === "Quiz" ? (
                                                                                                                                        <img src="/images/quiz-icon.svg" width="15px" height='13px' alt="" />
                                                                                                                                    ) : null}{" "}
                                                                                                                                    &nbsp; {items.type}
                                                                                                                                </p>
                                                                                                                        }
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                {
                                                                                                                    <div onClick={() => (items.type === 'Article' || items.type === 'Podcast') ? this.showArticles(items, "skillpod") : items.type === 'Course' ? this.goToOriginal(items, 'Course') : this.showfeeds(items, "skillpod")} className=" col-md-12 col-4 mt-1 d-flex justify-content-between align-items-start text-capitalize">
                                                                                                                        <p className="content-title">{items.title}</p>
                                                                                                                        {items.viewed ? (
                                                                                                                            <img src="/images/green-check-fill.svg" alt="" width="22px" />
                                                                                                                        ) : (
                                                                                                                            <img src="/images/grey-check-fill.svg" alt="" width="22px" />
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                }
                                                                                                                <p className="caption-text col-md-12 pr-2" style={{ fontSize: 12, marginTop: 3, display: 'flex', justifyContent: 'space-between' }}>
                                                                                                                    {items.type === 'Quiz' ? <p style={{ color: '#8b7df2', fontWeight: 600 }} onClick={() => this.showQuiz(items)}>Start Quiz</p> : items.type === "Video" ? time1 !== "00:00" ? `${time1}` : null : items?.source !== undefined && `${items.source}`}
                                                                                                                    <span>{items.type === 'Quiz' ? <img src='/images/info-icon.svg' alt='' style={{ marginTop: 3, cursor: 'pointer', marginRight: 9 }} width={18} onClick={() => this.openTestDetail(items._id)} /> : (items.type === "Article" && '02:00')}</span>
                                                                                                                </p>

                                                                                                            </div>

                                                                                                        </div>
                                                                                                    );
                                                                                                })}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                }
                                            </Fragment>
                                            :
                                            isDataLoading ? (
                                                <div className="loading-center pl-2 pr-2">
                                                    <TopicLoader />
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className="additional-resource-holder"
                                                        style={{
                                                            height: window.innerWidth > 767 ? 760 : 510,
                                                            overflow: "auto",
                                                            overflowX: "hidden",
                                                            borderBottomLeftRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                        }}
                                                        id="historyDiv"
                                                    >{
                                                            additionalContent !== null &&
                                                            <Fragment>
                                                                <h1>{contentType}</h1>
                                                                <InfiniteScroll
                                                                    dataLength={additionalContent !== undefined && additionalContent?.length} //This is important field to render the next data
                                                                    next={this.fetchAdditionalContent}
                                                                    hasMore={true}
                                                                    style={{ overflow: "unset" }}
                                                                    scrollableTarget="historyDiv"
                                                                    loader={isDataLoading ? <TopicLoader /> : null}
                                                                >
                                                                    <div className="row">
                                                                        {additionalContent !== null &&
                                                                            additionalContent?.length > 0 ?
                                                                            additionalContent.map((items, index) => {
                                                                                var startTime = items?.type === 'Video' ? (items.duration && items.duration !== undefined && items.duration.split("-")[0].split(":").reverse().reduce((prev, curr, i) =>
                                                                                    prev + curr * Math.pow(60, i),
                                                                                    0
                                                                                )) : 0;
                                                                                var endTime = items?.type === 'Video' ? (items.duration && items.duration !== undefined && items.duration.split("-")[1].split(":").reverse().reduce((prev, curr, i) =>
                                                                                    prev + curr * Math.pow(60, i),
                                                                                    0
                                                                                )) : 0;
                                                                                var time1 = secondsToTime1(endTime - startTime);
                                                                                return (
                                                                                    <div key={index} className="col-md-3 col-12 position-relative cursor-pointer" >
                                                                                        <div className="row mt-4">
                                                                                            <div className="col-md-12 col-6" onMouseOver={(e) => { this.mouseover(e, items?._id) }} onMouseOut={(e) => { this.mouseout(e) }} onClick={() => (items.type === 'Article' || items?.type === 'Podcast') ? this.showArticles(items, "additional") : items.type === 'Course' ? this.goToOriginal(items, 'Course') : this.showfeeds(items, "additional")} >

                                                                                                <img src={items.image} width='100%' height={120} alt="" loading="lazy" style={{ borderRadius: 8, border: '1px solid rgb(233, 232, 242)' }} onError={(e) => {
                                                                                                    if (e.target.src !== "/images/empty-image.png") {
                                                                                                        e.target.onerror = null;
                                                                                                        e.target.src = "/images/empty-image.png";
                                                                                                    }
                                                                                                }
                                                                                                } />
                                                                                                <div className="content-tags" style={{ background: this.state.isHover && (this.state.itemid === items?._id) ? '#8B7DF2' : '#E7C15F' }}>
                                                                                                    {
                                                                                                        this.state.isHover && (this.state.itemid === items?._id) ?
                                                                                                            <p className="d-flex align-items-center" style={{ color: '#fff' }}>
                                                                                                                {items.type === "Podcast" ? (
                                                                                                                    <img src="/images/podcast-icon-white.svg" width="15px" alt="" />
                                                                                                                ) : items.type === "Video" ? (
                                                                                                                    <img src="/images/video-icon-white.svg" width="15px" alt="" />
                                                                                                                ) : items.type === "Document" ? (
                                                                                                                    <img src="/images/document-icon-white.svg" width="14px" alt="" />
                                                                                                                ) : items.type === "Course" ? (
                                                                                                                    <img src="/images/course-icon-white.svg" width="15px" alt="" />
                                                                                                                ) : items.type === "Article" ? (
                                                                                                                    <img src="/images/article-icon-white.svg" width="15px" alt="" />
                                                                                                                ) : items.type === "Question" ? (
                                                                                                                    <img src="/images/quiz.svg" width="15px" alt="" />
                                                                                                                ) : null}{" "}
                                                                                                                &nbsp;
                                                                                                                {items.type === "Video" ? 'Watch Video' : items.type === "Document" ? 'Read Document' : items.type === "Article" ? 'Read Article' : items.type === "Podcast" ? 'Listen Podcast' : items.type === "Course" ? 'Watch Course' : null}
                                                                                                            </p> :
                                                                                                            <p className="d-flex align-items-center">
                                                                                                                {items.type === "Podcast" ? (
                                                                                                                    <img src="/images/podcast-icon-black.svg" width="15px" alt="" />
                                                                                                                ) : items.type === "Video" ? (
                                                                                                                    <img src="/images/video-icon-black.svg" width="15px" alt="" />
                                                                                                                ) : items.type === "Document" ? (
                                                                                                                    <img src="/images/document-icon-black.svg" width="12px" alt="" />
                                                                                                                ) : items.type === "Course" ? (
                                                                                                                    <img src="/images/course-icon-black.svg" width="15px" alt="" />
                                                                                                                ) : items.type === "Article" ? (
                                                                                                                    <img src="/images/article-icon-black.svg" width="15px" alt="" />
                                                                                                                ) : items.type === "Question" ? (
                                                                                                                    <img src="/images/quiz.svg" width="15px" alt="" />
                                                                                                                ) : null}{" "}
                                                                                                                &nbsp; {items.type}
                                                                                                            </p>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                            <div onClick={() => (items.type === 'Article' || items.type === 'Podcast') ? this.showArticles(items, "additional") : items.type === 'Course' ? this.goToOriginal(items, 'Course') : this.showfeeds(items, "additional")} className=" col-md-12 col-4 mt-1 d-flex justify-content-between align-items-start text-capitalize">
                                                                                                <p className="content-title">{items.title}</p>
                                                                                                {items.viewed ? (
                                                                                                    <img src="/images/green-check-fill.svg" alt="" width="22px" />
                                                                                                ) : (
                                                                                                    <img src="/images/grey-check-fill.svg" alt="" width="22px" />
                                                                                                )}
                                                                                            </div>
                                                                                            <p className="caption-text col-md-12" style={{ fontSize: 12, marginTop: 3, display: 'flex', justifyContent: 'space-between' }}>
                                                                                                {items.type === "Video" ? time1 !== "00:00" ? `${time1}` : null : items.source !== undefined && `${items.source}`}
                                                                                                <span>{items.type === "Article" && '02:00'}</span>
                                                                                            </p>

                                                                                        </div>

                                                                                    </div>
                                                                                );
                                                                            })
                                                                            :
                                                                            null
                                                                        }
                                                                    </div>
                                                                </InfiniteScroll>
                                                            </Fragment>

                                                        }

                                                    </div>
                                                </div>
                                            )}

                                    </div>
                                </div > :
                                <div className="elite-courses">
                                    <div className="elite-course-details">
                                        <div className="d-flex align-items-start">
                                            <img src='/images/chevron-left.svg' alt='' className='cursor-pointer'
                                                onClick={() => this.onback()}
                                            />&nbsp;&nbsp;
                                            <div className="w-65 d-flex cursor-pointer">
                                                <img src={courseDetails?.image} alt='' className='rounded' width={200} height={90} />&nbsp;&nbsp;&nbsp;
                                                <div>
                                                    <h4>{courseDetails?.source}</h4>
                                                    <h3>{courseDetails?.title}</h3>
                                                </div>

                                            </div>
                                            <div className='w-35 d-flex justify-content-end align-items-center mr-4'>
                                                <a href={courseDetails?.url} target='_blank'>
                                                    <button className='course-btn' style={{ background: theme?.bgColor }} >Go to course</button>
                                                </a>
                                                <div className='d-flex align-items-center pl-4 cursor-pointer' onClick={() => this.props.shareFeed({ ...courseDetails, type: 'Course' })}>
                                                    <img src='/images/share.svg' alt='' /><p style={{ fontSize: 14, color: '#535259', fontWeight: 700 }}>Share</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mark-status'>
                                            <h5>Mark course status</h5>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex'>
                                                    <button style={{ background: this.state.status === 'not_interested' ? theme?.bgColor : '', color: this.state.status === 'not_interested' ? '#fff' : '' }} onClick={() => this.updateStatus(courseDetails, 'not_interested')}>Not Interested</button>
                                                    <button style={{ background: this.state.status === 'started' ? theme?.bgColor : '', color: this.state.status === 'started' ? '#fff' : '' }} onClick={() => this.updateStatus(courseDetails, 'started')}>Started</button>
                                                    <button style={{ background: this.state.status === 'completed' ? theme?.bgColor : '', color: this.state.status === 'completed' ? '#fff' : '' }} onClick={() => this.updateStatus(courseDetails, 'completed')}>Completed</button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {(this.state?.status === 'started' || this.state?.status === 'completed') ?
                                        <div style={{}}>
                                            <div className='d-flex align-items-center justify-content-between course-details'>
                                                <div className='d-flex align-item-center'>Current Status :&nbsp;&nbsp;&nbsp;
                                                    <CourseProgressBar value={courseDetails?.status === 'started' ? 50 : courseDetails?.status === 'completed' ? 100 : 0} boxNumber={3} />
                                                </div>&nbsp;&nbsp;&nbsp;&nbsp;
                                                <div className='d-flex align-items-center'>Start Date* :
                                                    <div className='select-date position-relative'>
                                                        <input type='date' className='form-control' onChange={(e) => this.setDate(e.target.value, 'start')} />
                                                        <div className='d-flex align-items-center'>
                                                            <input className='form-control' placeholder='Select date' value={this.state.start} required style={{ color: '#fff' }} />
                                                            <img src='/images/arrow-down.svg' alt='' width={10} />
                                                        </div>
                                                    </div>

                                                </div>&nbsp;&nbsp;&nbsp;&nbsp;
                                                <div className='d-flex align-items-center'>Target Completion Date* :
                                                    <div className='select-date position-relative'>
                                                        <input type='date' className='form-control' onChange={(e) => this.setDate(e.target.value, 'completed')} />
                                                        <div className='d-flex align-items-center'>
                                                            <input className='form-control' placeholder='Select date' value={this.state.complete} required style={{ color: '#fff' }} />
                                                            <img src='/images/arrow-down.svg' alt='' width={10} />
                                                        </div>
                                                    </div>

                                                </div>
                                                {
                                                    courseDetails?.certificate !== null ?
                                                        <a href={courseDetails?.certificate} target='_blank' rel="noreferrer">
                                                            <button style={{ minWidth: 180, background: '#8b7df2', color: '#fff', border: 'none' }}  >
                                                                View Certificate
                                                            </button>
                                                        </a>
                                                        : (<button disabled={courseDetails?.completed_at ? false : true} style={{ minWidth: 180, background: checkDateDifference(this.state?.completed_at) ? '#8b7df2' : '#82818c', cursor: this.state?.completed_at ? 'pointer' : 'not-allowed', color: '#fff', border: 'none' }}  >
                                                            <input type='file' disabled={checkDateDifference(this.state?.completed_at) ? false : true} className='file-upload ' style={{ cursor: checkDateDifference(this.state?.completed_at) ? 'pointer' : 'not-allowed' }} ref="uploadImg" onChange={(e) => this.imageUpload(e, courseDetails?._id)} />
                                                            Upload Certificate
                                                        </button>)
                                                }
                                                <div className='cursor-pointer' onClick={(this.state.update && (this.state.complete !== null && this.state.start !== null)) ? this.saveDates : this.showMessage}>
                                                    Save
                                                </div>
                                            </div>
                                        </div> :
                                        null
                                    }
                                    {(this.state?.status === 'started' || this.state?.status === 'completed') ? <p style={{ fontSize: 12, fontFamily: 'Roboto' }}>Fields marked * are mandatory</p> : null}

                                    {
                                        courseDetails?.userCourses ?
                                            <div className='course-desc'>
                                                {courseDetails?.userCourses ?
                                                    <h2 className='d-flex justify-content-end pb-1' onClick={() => this.setState({ edit: true })}><img src='/images/edit.svg' alt='' /></h2>
                                                    : null
                                                }
                                                {

                                                    <div className='form-group'>
                                                        <h5>Course Title</h5>
                                                        {edit ?
                                                            <input className='form-control mt-2' name='title' value={this.state.title} onChange={(e) => this.changeContent(e)} /> :
                                                            <div >
                                                                <p>{courseDetails?.title}</p>
                                                            </div>
                                                        }
                                                        <span style={{ color: 'red' }}>{this.state.titleErr}</span>
                                                    </div>

                                                }


                                                <div className='form-group'>
                                                    {(this.state?.description || edit) ? <h5>Course Description</h5> : null}
                                                    {
                                                        edit ?
                                                            <textarea className='form-control mt-2' name='description' value={this.state.description} onChange={(e) => this.changeContent(e)} />
                                                            :
                                                            (courseDetails?.description &&
                                                                <div >
                                                                    <p>{courseDetails?.description}</p>
                                                                </div>
                                                            )
                                                    }
                                                </div>
                                                <div className='form-group'>
                                                    <h5>Course Url</h5>
                                                    {
                                                        edit ?
                                                            <input className='form-control mt-2' name='url' value={this.state.url} onChange={(e) => this.handleChangeUrl(e)} />
                                                            :
                                                            <div >
                                                                <p>{courseDetails?.url}</p>
                                                            </div>
                                                    }
                                                    <span style={{ color: 'red' }}>{this.state.urlErr}</span>
                                                </div>
                                                <div className='form-group'>

                                                    {
                                                        edit ?
                                                            <div className='d-flex'>
                                                                <button className='button-color' style={{ width: 180, height: 40, borderRadius: 4, textAlign: 'center', background: theme?.bgColor }} onClick={() => this.editCourse()}>
                                                                    Submit
                                                                </button>&nbsp;&nbsp;
                                                                <button style={{ width: 180, height: 40, color: '#242326', borderRadius: 4, textAlign: 'center', background: '#fff', border: '1px solid #ddd' }} onClick={() => this.setState({ edit: false })}>
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            <div className='course-desc'>
                                                {courseDetails?.description && <div >
                                                    <h5>Course description</h5>
                                                    <p>{courseDetails?.description}</p>
                                                </div>}
                                                {
                                                    courseDetails?.author ?
                                                        <div className='mt-4' >
                                                            <h5>Course author</h5>
                                                            <p>{courseDetails?.author}</p>
                                                        </div>
                                                        : null
                                                }
                                            </div>
                                    }
                                </div>
                        }
                    </Fragment>
                    : 'loading..'
                }
                {/* Model for youtube Video */}

                <Modal
                    show={this.props.isShow}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={"elite-content-holder"}
                >
                    <div
                        className="sticky-close"
                        onClick={() => this.closeVideo()}
                    >
                        <img src="/images/close-white.svg" alt='' />
                    </div>
                    <div className="main-modal-header">
                        <h3 >{activeFeedData?.title}
                        </h3>
                        <p>{activeFeedData?.source}&nbsp;&nbsp; <span style={{ color: '#8B7DF2', cursor: 'pointer' }} onClick={() => this.goToOriginal(activeFeedData, activeFeedData?.type)}>View Original <img src='/images/external1.svg' alt='' /></span></p>
                    </div>
                    <div className='p-3'>
                        {(activeFeedData?.type === "Podcast") ?
                            <div className='description'>
                                <div className='m-0'>
                                    <div className='col-md-12'>
                                        <p className={activeFeedData.type === "Podcast" ? '' : 'elipsis text-justify'} dangerouslySetInnerHTML={{
                                            __html: activeFeedData !== undefined && activeFeedData?.description
                                        }} />
                                        <div className="mt-2">
                                            <span className="imgdiv">
                                                {
                                                    activeFeedData?.type === "Podcast" && activeFeedData?.audio !== null && activeFeedData?.audio !== undefined ?

                                                        <div className="d-flex justify-content-center">
                                                            <ReactAudioPlayer
                                                                //   src='"http://feeds.dabcc.com/~r/dabcc-radio/~5/4bTJ2oaaSgs/e293_datacore.mp3"'
                                                                src={activeFeedData.audio !== null && activeFeedData.audio}
                                                                autoPlay
                                                                controls
                                                            // onError={() => this.onError(activeFeedData.type, activeFeedData._id)}
                                                            />
                                                        </div>
                                                        :
                                                        <img
                                                            src={activeFeedData !== undefined && activeFeedData.image ? activeFeedData.source === "tunein" ? "/images/empty-image.png" : activeFeedData.image : "/images/empty-image.png"} alt=''
                                                            width='100%' height='320px'
                                                            onError={(e) => {
                                                                if (e.target.src !== "/images/empty-image.png") {
                                                                    e.target.onerror = "/images/empty-image.png";
                                                                    e.target.src = "/images/empty-image.png";
                                                                }
                                                            }} />

                                                }
                                            </span>

                                        </div>

                                    </div>

                                </div>

                            </div> :
                            activeFeedData?.type === "Video" ?

                                (activeFeedData?.source === "Vimeo" || activeFeedData?.source === "vimeo.com") ?
                                    (this.props.status === 404 ?
                                        <div className='text-center' style={{ paddingTop: 50, fontSize: 30 }}>
                                            This video coming soon.Please try another video
                                        </div> :
                                        <ReactPlayer url={activeFeedData.url}
                                            config={{
                                                vimeo: {
                                                    // playerOptions: { start: startTime, end: endTime, disablekb: 1, rel: 0 },
                                                }
                                            }}
                                            fallback={'loading...'}
                                            style={{ overflow: 'hidden' }}
                                            controls playing={true} autoPlay width='100%' height={window.innerWidth > 767 ? 385 : '100%'}
                                            onPlay={() => this.onPlayChange()}
                                            onPause={() => this.onPause(true)}
                                            onEnded={() => this.onEnded()}
                                            onError={(err) => this.handleError(err, activeFeedData?.type, activeFeedData?._id)}
                                        />)
                                    : (activeFeedData?.source === "Youtube" || activeFeedData?.source === "YouTube" || activeFeedData?.source === "youtube.com" || activeFeedData.source === "youtu.be") ?
                                        <ReactPlayer url={activeFeedData.url}
                                            config={{
                                                youtube: {
                                                    playerVars: { start: startTime, end: endTime, disablekb: 1, rel: 0 },
                                                    embedOptions: {
                                                        host: this.state.videoFailed ? '' : 'https://www.youtube-nocookie.com',
                                                        // events: {
                                                        //     'onStateChange': this.onStateChange
                                                        // }
                                                    }
                                                },
                                            }}
                                            fallback={'loading...'}
                                            controls playing={true} autoPlay width='100%' height={window.innerWidth > 767 ? 385 : '100%'}
                                            style={{ overflow: 'hidden' }}
                                            onPlay={() => this.onPlayChange()}
                                            onPause={() => this.onPause(true)}
                                            onEnded={() => this.onEnded()}
                                            onError={(err) => this.handleError(err, activeFeedData?.type, activeFeedData?._id)}
                                        />
                                        :
                                        (this.props.activeFeedData?.source !== "Vimeo" || this.props.activeFeedData?.source === "NTTF" || this.props.activeFeedData?.source !== "vimeo.com" || this.props.activeFeedData.source !== "Youtube" || this.props.activeFeedData.source !== "youtube.com" || this.props.activeFeedData.source !== "youtu.be") ?
                                            <ReactPlayer
                                                url={this.props.activeFeedData.url}
                                                config={{
                                                    youtube: {
                                                        playerVars: { start: startTime, end: endTime, disablekb: 1, rel: 0 },
                                                        embedOptions: {
                                                            host: activeFeedData.url?.includes('youtube') ? 'https://www.youtube-nocookie.com' : '',
                                                            // events: {
                                                            //     'onStateChange': this.onStateChange
                                                            // }
                                                        }

                                                    }
                                                }}
                                                fallback={'loading...'}
                                                controls playing={true} autoPlay width='100%' height={window.innerWidth > 767 ? 385 : '100%'}
                                                onPlay={() => this.onPlayChange()}
                                                onPause={() => this.onPause(true)}
                                                onEnded={() => this.onEnded()}
                                                onError={(err) => this.handleError(err, activeFeedData?.type, activeFeedData?._id)}
                                                style={{ overflow: 'hidden' }}
                                            />
                                            : null : null

                        }
                        {
                            activeFeedData &&
                            <ul className='like-btn' style={{ marginLeft: window.innerWidth > 767 ? '' : 27 }} >
                                <li onClick={() => this.saveContent(activeFeedData?.type, activeFeedData?._id)}>
                                    <img src='/images/saved-disable.svg' alt='' /> {t('save')}
                                </li>
                                <li className={activeFeedData?.liked ? "liked-active" : null}
                                    onClick={() => this.props.onLikeClick(activeFeedData)}
                                >
                                    {
                                        activeFeedData.liked ?
                                            <img src="/images/enable-like.svg" alt='' /> :
                                            <img src="/images/disable-like.svg" alt='' />
                                    }&nbsp;
                                    {
                                        activeFeedData?.liked ? t('liked') : t('like')
                                    }
                                </li>

                                <li
                                    onClick={() => this.props.shareFeed(activeFeedData)}
                                >
                                    <img src='/images/share-icon-grey.svg' alt='' /> {t('Share')}
                                </li>
                            </ul >
                        }
                    </div>
                </Modal>

                {/* ############## Add To Skill Pod modal ################################ */}
                <SelectBubble
                    addToBubble={this.state.addToBubble}
                    podList={this.props.podList}
                    selectBubble={this.selectBubble}
                    resetModal={this.resetModal}
                    addSkillPod={this.props.addSkillPod}
                    theme={this.props.theme}
                />

                {/* ############## add and edit pod modal ############### */}
                <Modal
                    show={this.props.isOpen}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={"add-topic-modal"}
                >
                    <AddPodModal
                        handleModal={this.handleModal}
                        edit={this.props.edit}
                        rtype={this.state.r_type}
                        rId={this.state.r_id}
                        addResourceToPod={this.props.addResourceToPod}
                        resetModal={this.resetModal}
                        clearErrors={this.props.clearErrors}
                        savedPod={this.props.savedPod}
                        podDetails={this.props.podDetails}
                        // active={this.state.activeBtn}
                        theme={this.props.theme}
                    />
                </Modal>


                {/* -----Test details View----------*/}

                <TestDetail
                    isOpenDetail={this.state.isOpenDetail}
                    handleIntroModalClose={() => this.setState({ isOpenDetail: false })}
                    testDetails={this.props.quizHistory}
                    type='history'
                    t={this.props.t}
                    setLoading={this.state.setLoading}
                />

                {/* -----Share popup View----------*/}

                <SharePopup
                    isShareFeedPopup={this.props.isShareFeedPopup}
                    shareObj={this.props.shareObj}
                    shareModalClose={this.props.shareModalClose}
                    shareAll={this.props.shareAll}
                    successEnable={this.props.successEnable}
                    successMessageText={this.props.successMessageText}
                    snackClosed={this.snackClosed}
                />

                {
                    window.innerWidth > 767 &&
                    <Modal
                        show={this.state.article}
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        dialogClassName={"elite-content-holder content-modal-width"}
                    >

                        <div className="main-modal-header">
                            <h3 >{activeFeedData?.title}
                            </h3>
                            <p>{activeFeedData?.source}</p>
                        </div>

                        <div className='p-3 text-center'>
                            <p style={{ color: '#000000' }}>This article is being viewed in a different pop up. Please close it to continue acessing other content.<br />
                                <img src={activeFeedData?.image} alt='' width='100%' height='160px' />
                                <br />
                                To share/save/like the article click on the buttons below</p>

                            {activeFeedData && <ul className='like-btn justify-content-center' style={{ marginLeft: window.innerWidth > 767 ? '' : 27 }} >
                                <li onClick={() => this.saveContent(activeFeedData?.type, activeFeedData?._id)}>
                                    <img src='/images/saved-disable.svg' alt='' /> {t('save')}
                                </li>
                                <li className={activeFeedData?.liked ? "liked-active" : null}
                                    onClick={() => this.props.onLikeClick(activeFeedData)}
                                >
                                    {
                                        activeFeedData.liked ?
                                            <img src="/images/enable-like.svg" alt='' /> :
                                            <img src="/images/disable-like.svg" alt='' />
                                    }&nbsp;
                                    {
                                        activeFeedData?.liked ? t('liked') : t('like')
                                    }
                                </li>

                                <li
                                    onClick={() => this.props.shareFeed(activeFeedData)}
                                >
                                    <img src='/images/share-icon-grey.svg' alt='' /> {t('Share')}
                                </li>
                            </ul >}
                            <button style={{ backgroundColor: theme?.bgColor }} className="button-color" onClick={() => this.goToArticles(activeFeedData?.url, false)}>Close {activeFeedData?.type}</button>
                        </div>
                    </Modal>
                }

                {/* ##########  modal ############### */}
                <Modal
                    show={this.state.openWarn}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    // onHide={this.handleCloseModal}
                    dialogClassName={"confirm-modal"}
                >
                    <div
                        className={
                            window.innerWidth > 767 ? "p-3 text-center" : "p-2 text-center"
                        }
                    >
                        <h1 style={{ fontSize: window.innerWidth > 767 ? 18 : 15 }}>
                            {this.state.msg == null ?
                                'Course details is not updated yet.please save details'
                                : this.state.msg ?
                                    'Your course status is not updated completely. Please add the required details and save.'
                                    : 'Your course update is not saved. Please add the required details and save'

                            }
                        </h1>
                        <div className="save-btn">
                            <div className="save-btn">
                                <button onClick={() => this.setState({ openWarn: false })}>Ok</button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <div className="feeds-details" style={{ zIndex: 7, display: this.state.isOpenQuiz ? "block" : "none", top: 0, width: "100%" }}>
                    <QuizPopup
                        activeFeedData={this.props.activeFeedData}
                        questions={this.props.questions}
                        question={this.state.question}
                        quiz={this.state.quiz}
                        selectAnswer={this.props.selectAnswer}
                        quizSubmitted={this.props.quizSubmitted}
                        viewAnalytic={this.props.viewAnalytic}
                        closePopup={this.closePopup}
                    />
                </div>
            </div >
        )
    }
}


export default withRouter(ContentDetails)